<template>
  <v-form ref="form" v-model="valid" @submit="send">
    <div>
      <v-container class="pt-0">
        <span class="headline">{{$t('contact.title')}}</span>
        <v-row>
          <v-col cols="12" :md="6">
            <v-text-field
              data-test-id="email"
              v-model="email"
              :disabled="true"
              name="email"
              :label="$t('contact.your-email-address')"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-textarea
              v-model="message"
              name="input-message"
              :disabled="loading"
              :label="$t('contact.your-message')"
              :rows="messageRows"
              hint
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col>
            <v-btn
              data-test-id="submitButton"
              type="submit"
              color="primary"
              :disabled="!valid || !filled || loading"
              :loading="loading"
            >
              <v-icon left>mdi-send</v-icon>{{$t('contact.send-message')}}
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="12" class="mt-3">
            <span class="body-2">{{$t('contact.feedback-note', {product: $tenant.title})}}</span>
          </v-col>
        </v-row>
        <v-row cols="12" no-gutters>
          <v-col cols="12">
            <v-btn @click="openGoogleFeedback" class="secondary">
              <v-icon left>mdi-open-in-app</v-icon>{{$t('contact.feedback-button-text')}}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-container>
        <advertising-content/>
      </v-container>
    </div>
  </v-form>
</template>

<script>
import { MUTATION_RAISE_NOTIFICATION } from "@/plugins/store.js";
import AdvertisingContent from '../widgets/AdvertisingContent.vue';

export default {
  name: "Contact",
  components: {
    AdvertisingContent
  },
  data: () => ({
    valid: true,
    loading: false,
    email: undefined,
    message: undefined
  }),

  computed: {
    filled() {
      return (
        this.email &&
        this.email.length > 0 &&
        this.message &&
        this.message.length > 0
      );
    },
    messageRows() {
      var ret = 7;
      if (this.$vuetify.breakpoint.mdAndUp) {
        ret = 12;
      }
      return ret;
    }
  },

  mounted: function() {
    this.email = this.$store.state.profile.email;
  },

  methods: {
    send(e) {
      e.preventDefault();
      this.loading = true;
      this.$http
        .post("/api/user/contact", {
          message: this.message
        })
        .then(() => {
          this.loading = false;
          this.reset();
          let msg = "Nachricht erfolgreich gesendet. Wir antworten dir zeitnah per E-Mail.";
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            type: "success",
            message: msg
          });
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
      return false;
    },
    reset() {
      this.message = undefined;
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    openGoogleFeedback() {
      let url = "https://g.page/eSpocial/review?gm";
      if (this.$common.isRunningInStandalone()) {
        this.$common.openPopupWindow(url);
      } else {
        this.$common.openBlankWindow(url);
      }
    }
  }
};
</script>
